
import { useNavigate, useParams } from "react-router-dom";
import SideBar from "../../components/UserDashboard/SideBar";
import EnergyHeader from "../../components/energy/energyHeader";
import Rocket from "../../images/Rocket-small.png";
import { useState } from "react";
import { EnergyTradingIntegration } from "../../instantiateTransaction/EnergySharing";

export default function WaitingForPayment() {
  const navigate = useNavigate();
  const { tradeId } = useParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleConfirmPayment = async () => {
    setLoading(true);
    setError("");
    try {
      const integration = new EnergyTradingIntegration("seller");
      await integration.init();
      await integration.completeListingTrade(Number(tradeId));
      setSuccess(true);
      setTimeout(() => navigate("/energy"), 1500);
    } catch (err) {
      setError(err.message || "Failed to confirm payment");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="energyListing">
      <div className="sidebar_container">
        <SideBar />
      </div>
      <div className="energyListing__inner">
        <EnergyHeader />

        <div className="energyListing__inner__energyListed">
          <img src={Rocket} />

          <div className="energyListing__inner__energyListed__title">
            Waiting for buyer’s payment
          </div>

          <div className="energyListing__inner__energyListed__subtitle">
            800kWh energy has been locked. Once payment has been made, energy will be transferred.
          </div>

          {error && <div style={{ color: "red", margin: "1rem 0" }}>{error}</div>}
          {success && <div style={{ color: "green", margin: "1rem 0" }}>Payment confirmed! Energy transferred.</div>}

          <button onClick={handleConfirmPayment} disabled={loading || success}>
            {loading ? "Confirming..." : "Confirm Payment Received"}
          </button>
          <button onClick={() => navigate("/energy")}>Done</button>
        </div>
      </div>
    </div>
  );
}
